import { GET_INTERACTIONS, SET_INTERACTIONS, API_ERROR } from "./actionTypes";

const initialState = {
  status: {},
  data: {},
  userList: {},
};

const Interactions = (state = initialState, action) => {
  
  switch (action.type) {
    case GET_INTERACTIONS:
      state = {
        ...state,
        status: {
          [action.payload.chatId]: {
            error: false,
            loading: true,
            success: false,
          }
        },
      };
      break;
    case SET_INTERACTIONS:
      state = {
        ...state,
        status: {
          [action.payload.chatId]: {
            error: false,
            loading: false,
            success: true,
          },
        },
        data: {
          ...state.data,
          [action.payload.chatId]: [
            ...action.payload.data?.interactions,
          ],
        },
        userList: {
          ...state.userList,
          [action.payload.chatId]: [
            ...action.payload.data?.userList,
          ],
        },
      }
      break;
    case API_ERROR:
      state = {
        ...state,
        status: {
          [action.payload.chatId]: {
            error: action.payload.message,
            loading: false,
            success: false,
          }
        },
      };
      break;
    default:
      state = {
        ...state,
      }
      break;
  }
  return state;
};

export default Interactions;
